import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { FuseConfigService } from '../../../../../@fuse/services/config.service';
import { FuseTranslationLoaderService } from '../../../../../@fuse/services/translation-loader.service';
import { locale as english } from './i18n/en-CA';
import { locale as french } from './i18n/fr-CA';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AppRoutes } from '../../../../gt2/const/AppRoutes';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { NGXLogger } from 'ngx-logger';
import { SupportContactService } from '../../../../gt2/content/contact/support-contact.service';
import { GT2FormPageAbstract } from '../../../../gt2/content/abstract/GT2FormPageAbstract';
import { Settings } from '../../../../gt2/settings/settings';
import { AppRoutesService } from '../../../../gt2/services/app-routes.service';
import { GenericAlertComponent } from '../../../../gt2/components/generic-alert/generic-alert.component';
import { JwtInterceptor } from '../../../../gt2/interceptors/JwtInterceptor';
import { AuthenticationService } from '../../../../gt2/api/auth-service.service';
import { Title } from '@angular/platform-browser';
import { environment } from '../../../../../environments/environment';
import { Subscription, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SettingsService } from '../../../../gt2/settings/settings.service';

@Component({
  selector: 'error-503',
  templateUrl: './error-503.component.html',
  styleUrls: ['./error-503.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class Error503Component
  extends GT2FormPageAbstract
  implements OnInit, AfterViewInit, OnDestroy
{
  form: UntypedFormGroup | any;
  subject?: string;
  message?: string;
  last503URL?: string | any = null;
  readonly environment = environment;
  private healthCheckSub?: Subscription;
  isChecking = false;
  static readonly HEALTH_CHECK_INTERVAL_MS = 30_000;

  /*
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   */
  constructor(
    private _fuseConfigService: FuseConfigService,
    private router: Router,
    public location: Location,
    private translationLoader: FuseTranslationLoaderService,
    public translate: TranslateService,
    public dialog: MatDialog,
    private logger: NGXLogger,
    private auth: AuthenticationService,
    private formBuilder: UntypedFormBuilder,
    private titleService: Title,
    public appRoutesService: AppRoutesService,
    private supportContactService: SupportContactService,
    private settingsService: SettingsService,
  ) {
    super();
    this.translationLoader.loadTranslations(english, french);

    if (JwtInterceptor.LAST_URL_503) {
      this.last503URL = JwtInterceptor.LAST_URL_503;
    }

    // Configure the layout
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };

    //
    this.form = this.formBuilder.group({
      subject: [
        '',
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
          Validators.required,
        ],
      ],
      message: [
        '',
        [Validators.minLength(Settings.inputMinChar), Validators.required],
      ],
    });
  }

  ngOnInit() {
    //this.titleService.setTitle(this.translate.instant("GENERIC.ERROR"));
    this.startHealthCheck();
  }

  ngAfterViewInit() {}

  ngOnDestroy() {
    this.healthCheckSub?.unsubscribe();
  }

  private startHealthCheck(): void {
    this.healthCheckSub = timer(
      Error503Component.HEALTH_CHECK_INTERVAL_MS,
      Error503Component.HEALTH_CHECK_INTERVAL_MS,
    )
      .pipe(switchMap(() => this.settingsService.doPing()))
      .subscribe({
        next: () => this.onSystemBack(),
        error: () => {
          // Still down — keep polling
        },
      });
  }

  public onRetry(): void {
    if (this.isChecking) {
      return;
    }
    this.isChecking = true;
    this.settingsService.doPing().subscribe({
      next: () => {
        this.isChecking = false;
        this.onSystemBack();
      },
      error: () => {
        this.isChecking = false;
      },
    });
  }

  private onSystemBack(): void {
    this.healthCheckSub?.unsubscribe();
    const target = this.last503URL || '/';
    window.location.href = target;
  }

  public onSendContactForm(): void {
    // this.logger.info("Error503Component.onSendContactForm()");
    if (this.last503URL) {
      this.message +=
        ' - (url: ' +
        this.last503URL +
        '  version:' +
        environment.appVersion +
        ')';
      // this.logger.info("&&&&&&& -> " + this.message);
    }

    const email: any = {
      subject: '(Error 503 page) ' + this.subject,
      message: this.message,
    };
    this.supportContactService.postEmailError503(email).subscribe({
      next: (response) => {
        // this.logger.info("Error503Component.onSendContactForm() -> SUCCESS: " + JSON.stringify(response));
        this.showConfirmationDialog();
      },
      error: (error) => {
        this.logger.error(
          'Error503Component.onSendContactForm() -> ERROR: ' +
            JSON.stringify(error),
        );
      },
    });
  }

  public override onPageBack(): void {
    // this.logger.info(">>>>>>>>> ==> " + window.history.length);
    if (window.history.length > 1) {
      this.location.back();
    } else {
      const prefix = (localStorage.getItem('PREFIX') || '') + '/';
      this.router.navigateByUrl(prefix + AppRoutes.EVENTS);
    }
  }

  public onVisitGt2(): void {
    window.open('https://www.gestiontraiteur.com', '_blank');
  }

  public showConfirmationDialog(): void {
    this.subject = '';
    this.message = '';
    this.form.markAsUntouched();
    this.form.markAsPristine();

    this.dialogRef = this.dialog.open(GenericAlertComponent, {
      // width: '45%',
      disableClose: false,
    });
    this.dialogRef.componentInstance.alertTitle = '';
    this.dialogRef.componentInstance.alertMessage = this.translate.instant(
      'ERROR_503.SUCCESS_MESSAGE',
    );
    // this.dialogRef.componentInstance.showConfirmButton = false;

    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        this.dialogRef = null;
      },
    });
  }

  public onLogout(): void {
    // JwtInterceptor.LAST_URL_503 = null;
    this.auth.logout(true).subscribe({
      next: (response) => {
        // this.logger.info("Error503Component.onLogout() -> SUCCESS: " + JSON.stringify(response));
      },
      error: (error) => {
        this.logger.error(
          'Error503Component.onLogout() -> ERROR: ' + JSON.stringify(error),
        );
      },
    });
  }
}
